<template>
    <b-modal
        size="lg"
        v-model="mostrarModal"
        no-close-on-backdrop
        @close="fecharModal()"
        @show="preencher()"
    >
        <div slot="modal-title">
            Licitação -
            <b-badge variant="warning">{{ operacao }}</b-badge>
        </div>
        <b-row>
            <b-col cols="6">
                <b-form-group>
                    <label class="required">
                        Número do Processo
                    </label>
                    <b-form-input
                        v-model="numeroProcesso"
                        :maxlength="70"
                        placeholder="Informe o número do processo"
                        required
                    >
                    </b-form-input>
                </b-form-group>
            </b-col>
            <b-col cols="6">
                <b-form-group>
                    <label class="required">
                        Modalidade
                    </label>
                    <b-form-select
                        id="modalidade"
                        v-model="modalidade"
                        :options="modalidades"
                        text-field="descricao"
                        value-field="id"
                    >
                    </b-form-select>
                </b-form-group>
            </b-col>
        </b-row>
        <b-row>
            <b-col cols="12">
                <b-form-group>
                    <label class="required">
                        Objeto
                    </label>
                    <b-form-textarea
                        v-model="objeto"
                        placeholder="Informe o objeto da licitação"
                    >
                    </b-form-textarea>
                </b-form-group>
            </b-col>
        </b-row>
        <b-row>
            <b-col cols="6">
                <b-form-group>
                    <label class="required">
                        Valor Previsto
                    </label>
                    <b-input-group>
                        <money
                            v-model="valorPrevisto"
                            v-bind="money"
                            class="form-control text-right"
                        >
                        </money>
                    </b-input-group>
                </b-form-group>
            </b-col>
            <b-col cols="6">
                <b-form-group>
                    <label class="required">
                        Valor Contratado
                    </label>
                    <b-input-group>
                        <money
                            v-model="valorContratado"
                            v-bind="money"
                            class="form-control text-right"
                        >
                        </money>
                    </b-input-group>
                </b-form-group>
            </b-col>
        </b-row>
        <b-row>
            <b-col cols="6">
                <b-form-group>
                    <label class="required">
                        CNPJ Empresa Contratada
                    </label>
                    <b-form-input
                        v-model="cnpj"
                        placeholder="Informe o CNPJ"
                        v-mask="['##.###.###/####-##']">
                    </b-form-input>
                </b-form-group>
            </b-col>
        </b-row>
        <b-row>
            <b-col cols="6">
                <b-form-group>
                    <label class="required">
                        Data das Certidões de FGTS
                    </label>
                    <b-input-group>
                            <date-picker
                                id="dataCertidaoFGTS"
                                v-model="dataCertidaoFGTS"
                                :config="$datePickerOptions"
                                v-mask="'##/##/####'"
                           ></date-picker>
                            <b-form-invalid-feedback>Data da Certidão FGTS é Obrigatória!</b-form-invalid-feedback>
                        </b-input-group>
                </b-form-group>
            </b-col>
            <b-col cols="6">
                <b-form-group>
                    <label class="required">
                        Data da Certidão do INSS
                    </label>
                    <b-input-group>
                            <date-picker
                                id="dataCertidaoINSS"
                                v-model="dataCertidaoINSS"
                                :config="$datePickerOptions"
                                v-mask="'##/##/####'"
                           ></date-picker>
                            <b-form-invalid-feedback>Data da Certidão INSS é Obrigatória!</b-form-invalid-feedback>
                        </b-input-group>
                </b-form-group>
            </b-col>
        </b-row>
        <b-row>
            <b-col cols="6">
                <b-form-group>
                    <label>
                        Data da Certidão Municipal
                    </label>
                    <b-input-group>
                            <date-picker
                                id="dataCertidaoMunicipal"
                                v-model="dataCertidaoMunicipal"
                                :config="$datePickerOptions"
                                v-mask="'##/##/####'"
                               ></date-picker>
                            <b-form-invalid-feedback>Data da Certidão Municipal é Obrigatória!</b-form-invalid-feedback>
                        </b-input-group>
                </b-form-group>
            </b-col>
            <b-col cols="6">
                <b-form-group>
                    <label>
                        Data da Certidão Estadual
                    </label>
                    <b-input-group>
                            <date-picker
                                id="dataCertidaoEstadual"
                                v-model="dataCertidaoEstadual"
                                :config="$datePickerOptions"
                                v-mask="'##/##/####'"
                            ></date-picker>
                            <b-form-invalid-feedback>Data da Certidão Estadual é Obrigatória!</b-form-invalid-feedback>
                        </b-input-group>
                </b-form-group>
            </b-col>
        </b-row>
        <b-row>
            <b-col cols="6">
                <b-form-group label="Outras Empresas">
                    <b-form-input
                        placeholder="Informe outras empresas"
                        v-mask="['##.###.###/####-##']"
                        v-model="cnpjOutrasEmpresas"
                    >
                    </b-form-input>
                </b-form-group>
            </b-col>
            <b-col cols="6">
                <b-button
                    class="mt-4"
                    variant="outline-primary"
                    @click="adicionarEmpresa"
                    >Adicionar CNPJ</b-button
                >
            </b-col>
        </b-row>
        <div slot="modal-footer">
            <b-button variant="secondary" @click.stop="fecharModal()">
                Cancelar
            </b-button>
            <b-button
                variant="primary"
                :disabled="this.$v.$invalid"
                @click.stop="confirmarSalvar()"
                class="ml-1"
            >
                Salvar
            </b-button>
        </div>
        <empresas-licitacao-tabela
            :outrasEmpresas="outrasEmpresas"
            :temAcoes="true"
            :operacao="operacao"
            @excluirOutraEmpresa="excluirOutraEmpresa($event)"
        >
        </empresas-licitacao-tabela>
    </b-modal>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import EmpresasLicitacaoTabela from './EmpresasLicitacaoTabela'

export default {
    components: { EmpresasLicitacaoTabela },
    props: {
        convenio: Object,
        licitacao: Object,
        operacaoProp: String,
        mostrarModal: {
            type: Boolean,
            default: () => false
        },
        erros: {
            type: Array,
            default: () => []
        }
    },

    validations: {
        dataCertidaoFGTS:{required},
        dataCertidaoINSS:{required},
        dataCertidaoEstadual:{},
        dataCertidaoMunicipal:{},
        numeroProcesso: { required },
        modalidade: { required },
        objeto: { required },
        valorPrevisto: { required },
        valorContratado: { required },
        cnpj: { 
            eInsercao() {
                if (this.cnpj) {
                    return this.cnpj.length == 18
                }
                return false
            } }
    },

    data() {
        return {
            numeroProcesso: null,
            dataCertidaoFGTS:null,
            dataCertidaoINSS:null,
            dataCertidaoEstadual:null,
            dataCertidaoMunicipal:null,
            modalidades: [
                { id: 1, descricao: 'Concorrência' },
                { id: 2, descricao: 'Tomada de Preços' },
                { id: 3, descricao: 'Convite' },
                { id: 4, descricao: 'Concurso' },
                { id: 5, descricao: 'Leilão' },
                { id: 6, descricao: 'Pregão' },
                { id: 7, descricao: 'Chamamento Público' },
                { id: 8, descricao: 'Dispensa de Licitação' },
                { id: 9, descricao: 'Inexigibilidade de Licitação' }
            ],
            modalidade: null,
            objeto: null,
            valorPrevisto: 0,
            valorContratado: 0,
            cnpj: null,
            liberarBotao: false,
            outrasEmpresas: [],
            cnpjOutrasEmpresas: null,
            money: {
                decimal: ',',
                thousands: '.',
                prefix: 'R$ ',
                suffix: '',
                precision: 2,
                masked: false
            }
        }
    },

    computed: {
        operacao() {
            if (this.operacaoProp == 'I') {
                return 'INCLUSÃO'
            }
            return 'ATUALIZAÇÃO'
        }
    },

    methods: {
        preencher() {
            if (this.operacaoProp == 'A') {
                this.numeroProcesso = this.licitacao.numeroProcesso
                this.modalidade = this.licitacao.modalidade
                this.objeto = this.licitacao.objeto
                this.valorPrevisto = this.licitacao.valorPrevisto
                this.valorContratado = this.licitacao.valorContratado
                this.cnpj = this.licitacao.cnpj
                this.outrasEmpresas = this.licitacao.empresasLicitacao
                this.dataCertidaoFGTS = this.$moment(this.licitacao.dataCertidaoFGTS, 'YYYY-MM-DD').format('DD/MM/YYYY'),
                this.dataCertidaoINSS = this.$moment(this.licitacao.dataCertidaoINSS, 'YYYY-MM-DD').format('DD/MM/YYYY'),
                this.dataCertidaoEstadual = this.dataCertidaoEstadual ?  "" : this.$moment(this.licitacao.dataCertidaoEstadual, 'YYYY-MM-DD').format('DD/MM/YYYY'),
                this.dataCertidaoMunicipal = this.dataCertidaoMunicipal ? "" : this.$moment(this.licitacao.dataCertidaoMunicipal, 'YYYY-MM-DD').format('DD/MM/YYYY') ;
            }
        },

        fecharModal() {
            this.$emit('fechar')
            this.resetar()
        },

        resetar() {
            this.cnpj = null;
            this.numeroProcesso=null;
            this.objeto=""
            this.razaoSocial = null;
            
            this.naturezaDespesa = null;
            this.nomeEvento = null;
            this.valor = 0;
            this.formaAporte = null;
            this.valorPrevisto = 0;
            this.valorContratado = 0;
            this.dataCertidaoEstadual = "";
            this.dataCertidaoFGTS = "";
            this.dataCertidaoINSS = "";
            this.dataCertidaoMunicipal = "";
            this.outrasEmpresas=[];
            this.cnpjOutrasEmpresas="";
        },

        confirmarSalvar() {
            if (this.operacaoProp == 'I') {

                    this.$swal({
                    title: 'Licitação',
                    html: `Confirma a inserção da Licitação?`,
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Sim',
                    cancelButtonText: 'Não'
                }).then(result => {
                    if (result.value) {
                        this.salvar()
                    }
                })
            }
            else{

                this.$swal({
                    title: 'Licitação',
                    html: `Confirma a alteracão da Licitação?`,
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Sim',
                    cancelButtonText: 'Não'
                }).then(result => {
                    if (result.value) {
                        this.alterar()
                    }
                })

            }
        },

        excluirOutraEmpresa(cnpj) {
            let index = this.outrasEmpresas.findIndex(
                empresa => empresa.cnpj == cnpj
            )
            this.outrasEmpresas.splice(index, 1)
        },

        salvar() {
            let licitacaoDto = {
                cnpj: this.cnpj.replace(/\D+/g, ''),
                numeroProcesso: this.numeroProcesso,
                modalidade: this.modalidade,
                objeto: this.objeto,
                valorPrevisto: this.valorPrevisto,
                valorContratado: this.valorContratado,
                idConvenio: this.convenio.idConvenio,
                dataCertidaoFGTS: this.$moment(this.dataCertidaoFGTS, 'DD/MM/YYYY').format('YYYY-MM-DD'),
                dataCertidaoINSS: this.$moment(this.dataCertidaoINSS, 'DD/MM/YYYY').format('YYYY-MM-DD'),
                dataCertidaoEstadual: this.dataCertidaoEstadual ? this.$moment(this.dataCertidaoEstadual, 'DD/MM/YYYY').format('YYYY-MM-DD') : "",
                dataCertidaoMunicipal: this.dataCertidaoMunicipal ? this.$moment(this.dataCertidaoMunicipal, 'DD/MM/YYYY').format('YYYY-MM-DD'): "",
                empresasLicitacao: this.outrasEmpresas
            }
            if (this.operacaoProp == 'A') {
                licitacaoDto.idLicitacao = this.licitacao.idLicitacao
            }
            this.$emit('salvar', licitacaoDto)
            this.resetar()
        },

        alterar() {
            let licitacaoDto = {
                cnpj: this.cnpj.replace(/\D+/g, ''),
                numeroProcesso: this.numeroProcesso,
                modalidade: this.modalidade,
                objeto: this.objeto,
                valorPrevisto: this.valorPrevisto,
                valorContratado: this.valorContratado,
                idConvenio: this.convenio.idConvenio,
                dataCertidaoFGTS: this.$moment(this.dataCertidaoFGTS, 'DD/MM/YYYY').format('YYYY-MM-DD'),
                dataCertidaoINSS: this.$moment(this.dataCertidaoINSS, 'DD/MM/YYYY').format('YYYY-MM-DD'),
                dataCertidaoEstadual: this.dataCertidaoEstadual ? this.$moment(this.dataCertidaoEstadual, 'DD/MM/YYYY').format('YYYY-MM-DD') : "",
                dataCertidaoMunicipal: this.dataCertidaoMunicipal ? this.$moment(this.dataCertidaoMunicipal, 'DD/MM/YYYY').format('YYYY-MM-DD') : "",
                empresasLicitacao: this.outrasEmpresas
            }
            if (this.operacaoProp == 'A') {
                licitacaoDto.idLicitacao = this.licitacao.idLicitacao
            }
            this.$emit('alterar', licitacaoDto)
            this.resetar()
        },

        adicionarEmpresa() {
            this.outrasEmpresas.push({
                cnpj: this.cnpjOutrasEmpresas.replace(/\D+/g, '')
            })
            this.cnpjOutrasEmpresas="";
        }
    },

    watch: {
        cnpjOutrasEmpresas() {
            if (this.cnpjOutrasEmpresas.length >= 14) {
                this.liberarBotao = true
            }
            this.liberarBotao = false
        }
    }
}
</script>
